import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface SalesReportParams {
  from: string;
  to: string;
  type: string; // 'KU' | 'P' | 'A' | 'K'
  per: string; // timeMode
  sum: string; // sumMode
  subTotal?: boolean;
  custMode?: { external: boolean; internal: boolean };
}

export interface SalesReportItem {
  customername: string | null;
  invoiceCustomername?: string;
  project_name?: string;
  external_project_name?: string;
  activity_name?: string;
  external_activity_name?: string;
  name?: string;
  sum: number;
  pris: number;
  bonus?: number;
  ejbonus?: number;
}

@Injectable({
  providedIn: 'root',
})
export class SalesReportsService {
  constructor(@Inject(HttpClient) private http: HttpClient) {}

  getSalesReport(params: SalesReportParams): Observable<SalesReportItem[]> {
    let httpParams = new HttpParams()
      .set('type', params.type)
      .set('per', params.per)
      .set('sum', params.sum);

    if (params.subTotal !== undefined) {
      httpParams = httpParams.set('subTotal', String(params.subTotal));
    }

    if (params.custMode) {
      httpParams = httpParams.set('custMode', JSON.stringify(params.custMode));
    }

    return this.http.get<SalesReportItem[]>(`/api/sales/${params.from}/${params.to}`, {
      params: httpParams,
    });
  }
}
